<template lang="pug">
div(style="margin-top: -24px; margin-left: -15px; margin-right: -15px;")
  #FacturasUnificadas
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(style="border-radius: 5px; background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto; width: 140px;')
        v-card(style="border-radius: 5px; background-color: black;")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Módulo de Facturas (Fiscales y No Fiscales)

    //- Modal de Detalle de Factura (No Fiscal + Fiscal)
    v-dialog(v-model="dialogDetalle" max-width="880px")
      v-card(v-if="itemSel" style="background-color: white; border-radius: 12px; overflow: hidden;")
        v-card-title(style="background: #111827; color: white; padding: 14px 20px; display: flex; justify-content: space-between; align-items: center;")
          div(style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;")
            v-icon(color="#38bdf8") receipt
            span(style="font-size: 18px; font-weight: 800;")
              | Factura {{ itemSel.nro_doc ? '#' + itemSel.nro_doc : 'Fiscal #' + itemSel.factura_fiscal }}
            span(v-if="itemSel.nro_pedido" style="background: #1e293b; color: #cbd5e1; padding: 3px 10px; border-radius: 6px; font-size: 12px; font-weight: 600; border: 1px solid #334155;")
              | Pedido {{ '#' + itemSel.nro_pedido }}
            span(v-if="itemSel.tieneFiscal" style="background: #14532d; color: #bbf7d0; padding: 3px 10px; border-radius: 6px; font-size: 12px; font-weight: 700;")
              | Fiscal {{ '#' + itemSel.factura_fiscal }}
          v-btn(icon dark @click="dialogDetalle = false" style="margin: 0;")
            v-icon close

        v-card-text(style="padding: 20px;")
          //- Información del Cliente y Vendedor
          div(style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 14px 16px; margin-bottom: 16px;")
            v-layout(row wrap align-center)
              v-flex(xs12 md7)
                div(style="font-size: 11px; color: #64748b; font-weight: 700; text-transform: uppercase;") Cliente
                div(style="font-size: 16px; font-weight: 800; color: #0f172a; margin-top: 2px;") {{ itemSel.clienteNombre }}
                div(style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 6px;")
                  span(style="background: #e2e8f0; color: #334155; padding: 2px 8px; border-radius: 4px; font-size: 11px; font-weight: 700;")
                    | Cód: {{ itemSel.clienteCodigo }}
                  span(v-if="itemSel.clienteRif" style="color: #475569; font-size: 12px; font-weight: 600;")
                    | • RIF: {{ itemSel.clienteRif }}
                  span(v-if="itemSel.isContribEspecial" style="background: #e8f5e9; color: #2e7d32; border: 1px solid #a5d6a7; padding: 2px 8px; border-radius: 6px; font-size: 11px; font-weight: 700;")
                    | Contribuyente Especial (Ret. IVA {{ itemSel.porcRetStr }})
                  span(v-else style="background: #f1f5f9; color: #64748b; border: 1px solid #cbd5e1; padding: 2px 8px; border-radius: 6px; font-size: 11px; font-weight: 600;")
                    | Contribuyente Ordinario
              v-flex(xs12 md5 style="border-left: 1px solid #e2e8f0; padding-left: 14px;")
                div(style="font-size: 11px; color: #64748b; font-weight: 700; text-transform: uppercase;") Vendedor y Fechas
                div(style="font-size: 13px; color: #0f172a; font-weight: 700; margin-top: 2px;")
                  v-icon(small color="#0284c7" style="margin-right: 4px;") person
                  | {{ itemSel.ven_des }} ({{ itemSel.co_ven }})
                div(style="font-size: 12px; color: #475569; margin-top: 4px;")
                  span
                    b Emisión: 
                    | {{ formatearFecha(itemSel.fec_emis) }}
                  span(style="margin-left: 12px;" :style="{ color: itemSel.isVencida ? '#d32f2f' : '#475569', fontWeight: itemSel.isVencida ? '700' : '500' }")
                    b Vence: 
                    | {{ formatearFecha(itemSel.fec_venc) }}

          //- Bloques comparativos: No Fiscal (USD) y Fiscal (Bs)
          v-layout(row wrap style="margin: -6px;")
            //- 1. Desglose Factura No Fiscal (USD)
            v-flex(xs12 md6 style="padding: 6px;")
              div(style="background: #f8fafd; border: 1px solid #dce6f5; border-radius: 10px; padding: 14px; height: 100%;")
                div(style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;")
                  div(style="display: flex; align-items: center; gap: 6px;")
                    v-icon(small color="#0872e9") description
                    span(style="color: #0872e9; font-size: 13px; font-weight: 800;")
                      | Factura No Fiscal ({{ itemSel.nro_doc ? '#' + itemSel.nro_doc : 'N/A' }})
                  span(style="background: white; color: #0872e9; border: 1px solid #dce6f5; padding: 2px 8px; border-radius: 6px; font-size: 10px; font-weight: 700;")
                    | Divisas (USD)
                v-layout(row wrap)
                  v-flex(xs6)
                    div(style="font-size: 11px; color: #546e7a;") Total Factura
                    div(style="font-size: 16px; font-weight: 800; color: #1d1e25; margin-top: 2px;")
                      | $ {{ formatoMonto(itemSel.totalNoFiscal, 'USD') }}
                  v-flex(xs6)
                    div(style="font-size: 11px; color: #0872e9; font-weight: 700;") Saldo a Cobrar
                    div(style="font-size: 17px; font-weight: 900; color: #0872e9; margin-top: 2px;")
                      | $ {{ formatoMonto(itemSel.saldoNoFiscal, 'USD') }}
                div(v-if="itemSel.tasa" style="margin-top: 10px; padding-top: 8px; border-top: 1px dashed #dce6f5; font-size: 11px; color: #64748b;")
                  | Tasa referencial documento: 
                  b Bs. {{ formatoMonto(itemSel.tasa, 'BS') }}

            //- 2. Desglose Factura Fiscal (Bs)
            v-flex(xs12 md6 style="padding: 6px;")
              div(v-if="itemSel.tieneFiscal" style="background: #f6fbf7; border: 1px solid #c8e6c9; border-radius: 10px; padding: 14px; height: 100%;")
                div(style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;")
                  div(style="display: flex; align-items: center; gap: 6px;")
                    v-icon(small color="#2e7d32") verified_user
                    span(style="color: #2e7d32; font-size: 13px; font-weight: 800;")
                      | Factura Fiscal ({{ '#' + itemSel.factura_fiscal }})
                  span(style="background: white; color: #2e7d32; border: 1px solid #c8e6c9; padding: 2px 8px; border-radius: 6px; font-size: 10px; font-weight: 700;")
                    | {{ itemSel.tasaParaFiscal > 0 ? 'Tasa: ' + formatoMonto(itemSel.tasaParaFiscal, 'BS') + ' Bs' : 'Fiscal (Bs)' }}

                v-layout(row wrap style="margin-bottom: 8px;")
                  v-flex(xs6)
                    div(style="font-size: 11px; color: #78909c;") Subtotal Base
                    div(style="font-size: 13px; font-weight: 700; color: #37474f;")
                      | Bs. {{ formatoMonto(itemSel.subtotalFiscal, 'BS') }}
                  v-flex(xs6)
                    div(style="font-size: 11px; color: #78909c;") IVA (16% Total)
                    div(style="font-size: 13px; font-weight: 700; color: #37474f;")
                      | Bs. {{ formatoMonto(itemSel.ivaFiscal, 'BS') }}

                div(v-if="itemSel.tieneRetencion" style="background: #fff8e1; border: 1px solid #ffe082; border-radius: 8px; padding: 6px 10px; margin-bottom: 8px;")
                  div(style="display: flex; justify-content: space-between; font-size: 11px;")
                    span(style="color: #e65100; font-weight: 600;") Retención IVA ({{ itemSel.porcRetStr }}):
                    span(style="color: #c62828; font-weight: 700;") -Bs. {{ formatoMonto(itemSel.retencionBs, 'BS') }}
                  div(style="display: flex; justify-content: space-between; font-size: 11px; margin-top: 2px;")
                    span(style="color: #2e7d32; font-weight: 700;") IVA a Pagar ({{ itemSel.porcIvaPagarStr }}):
                    span(style="color: #2e7d32; font-weight: 800;") Bs. {{ formatoMonto(itemSel.ivaPagarBs, 'BS') }}

                v-layout(row wrap style="padding-top: 6px; border-top: 1px solid #dcfce7;")
                  v-flex(xs6)
                    div(style="font-size: 11px; color: #546e7a; font-weight: 600;")
                      | {{ itemSel.tieneRetencion ? 'Total Fiscal a Pagar' : 'Total Fiscal' }}
                    div(style="font-size: 14px; font-weight: 800; color: #1d1e25;")
                      | Bs. {{ formatoMonto(itemSel.tieneRetencion ? itemSel.totalFiscalAPagar : itemSel.totalFiscal, 'BS') }}
                  v-flex(xs6)
                    div(style="font-size: 11px; color: #2e7d32; font-weight: 700;") Saldo Fiscal
                    div(style="font-size: 15px; font-weight: 900; color: #2e7d32;")
                      | Bs. {{ formatoMonto(itemSel.saldoFiscal, 'BS') }}

              div(v-else style="background: #f5f7fa; border: 1px solid #eceff1; border-radius: 10px; padding: 24px 14px; height: 100%; display: flex; align-items: center; justify-content: center; color: #78909c;")
                v-icon(small color="#90a4ae" style="margin-right: 6px;") info_outline
                span(style="font-size: 12px; font-weight: 600;") Sin Factura Fiscal emitida asociada

          //- Comentario
          div(v-if="itemSel.comentario" style="margin-top: 14px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 8px; padding: 10px 14px; font-size: 12px; color: #92400e;")
            b Comentario / Nota: 
            | {{ itemSel.comentario }}

          //- Renglones / Artículos si existen
          div(v-if="itemSel.renglones && itemSel.renglones.length > 0" style="margin-top: 16px;")
            div(style="font-weight: 800; font-size: 13px; color: #1e293b; margin-bottom: 8px;")
              | Renglones de la Factura ({{ itemSel.renglones.length }}):
            div(style="max-height: 240px; overflow-y: auto; border: 1px solid #e2e8f0; border-radius: 8px;")
              table(style="width: 100%; border-collapse: collapse; font-size: 12px;")
                thead
                  tr(style="background: #f1f5f9; color: #475569; text-align: left; border-bottom: 1px solid #cbd5e1;")
                    th(style="padding: 8px 10px;") Código
                    th(style="padding: 8px 10px;") Cantidad
                    th(style="padding: 8px 10px;") Unidad
                    th(style="padding: 8px 10px; text-align: right;") Precio Unit.
                    th(style="padding: 8px 10px; text-align: right;") Neto
                tbody
                  tr(v-for="(r, idx) in itemSel.renglones" :key="idx" style="border-bottom: 1px solid #f1f5f9;")
                    td(style="padding: 7px 10px; font-weight: 700; color: #0284c7;") {{ r.co_art }}
                    td(style="padding: 7px 10px; font-weight: 600;") {{ r.total_art }}
                    td(style="padding: 7px 10px;") {{ r.co_uni || r.uni_venta || 'UND' }}
                    td(style="padding: 7px 10px; text-align: right;") $ {{ formatoMonto(r.prec_vta, 'USD') }}
                    td(style="padding: 7px 10px; text-align: right; font-weight: 700; color: #10b981;") $ {{ formatoMonto(r.reng_neto, 'USD') }}

        v-card-actions(style="padding: 12px 20px; background: #f1f5f9;")
          v-spacer
          v-btn(style="background: #111827; color: white; border-radius: 8px;" @click="dialogDetalle = false") Cerrar

    //- Contenido Principal
    v-container(fluid style="padding: 16px 20px;")
      //- KPIs Resumen (igual que el bloque superior del módulo de Cobros de la app)
      v-layout(row wrap style="margin-bottom: 14px;")
        v-flex(xs12 sm6 md3 style="padding: 6px;")
          v-card(color="white" style="border-radius: 10px; border-left: 5px solid #0872e9; padding: 12px 16px;" class="elevation-2")
            div(style="font-size: 11px; color: #64748b; font-weight: 700; text-transform: uppercase;") Facturas Mostradas
            div(style="font-size: 24px; font-weight: 900; color: #0872e9; margin-top: 2px;") {{ facturasFiltradas.length }}
            div(style="font-size: 11px; color: #475569; margin-top: 4px; display: flex; gap: 8px; flex-wrap: wrap;")
              span(style="color: #2e7d32; font-weight: 700;") • {{ kpis.conFiscal }} con Fiscal
              span(style="color: #64748b; font-weight: 600;") • {{ kpis.sinFiscal }} solo No Fiscal

        v-flex(xs12 sm6 md3 style="padding: 6px;")
          v-card(color="white" style="border-radius: 10px; border-left: 5px solid #0284c7; padding: 12px 16px;" class="elevation-2")
            div(style="font-size: 11px; color: #64748b; font-weight: 700; text-transform: uppercase;") Saldo a Cobrar (No Fiscal USD)
            div(style="font-size: 22px; font-weight: 900; color: #0284c7; margin-top: 2px;") $ {{ formatoMonto(kpis.totalSaldoUSD, 'USD') }}
            div(style="font-size: 11px; color: #64748b; margin-top: 4px;")
              | Total Facturado: 
              b(style="color: #0f172a;") $ {{ formatoMonto(kpis.totalMontoUSD, 'USD') }}

        v-flex(xs12 sm6 md3 style="padding: 6px;")
          v-card(color="white" style="border-radius: 10px; border-left: 5px solid #2e7d32; padding: 12px 16px;" class="elevation-2")
            div(style="font-size: 11px; color: #2e7d32; font-weight: 700; text-transform: uppercase;") Total IVA Fiscal (16%)
            div(style="font-size: 20px; font-weight: 900; color: #2e7d32; margin-top: 2px;") Bs. {{ formatoMonto(kpis.totalIvaBs, 'BS') }}
            div(style="font-size: 11px; color: #c62828; font-weight: 700; margin-top: 4px;")
              | Ret. Especiales: -Bs. {{ formatoMonto(kpis.totalRetencionBs, 'BS') }}

        v-flex(xs12 sm6 md3 style="padding: 6px;")
          v-card(color="white" style="border-radius: 10px; border-left: 5px solid #f59e0b; padding: 12px 16px;" class="elevation-2")
            div(style="font-size: 11px; color: #b45309; font-weight: 700; text-transform: uppercase;") IVA a Pagar / Total Fiscal Bs
            div(style="font-size: 20px; font-weight: 900; color: #d97706; margin-top: 2px;") Bs. {{ formatoMonto(kpis.totalIvaAPagarBs, 'BS') }}
            div(style="font-size: 11px; color: #475569; margin-top: 4px;")
              | Total Fiscal: 
              b(style="color: #0f172a;") Bs. {{ formatoMonto(kpis.totalFiscalBs, 'BS') }}

      //- Barra de Filtros y Controles
      v-card(color="white" style="border-radius: 10px; padding: 14px 16px; margin-bottom: 18px;" class="elevation-2")
        v-layout(row wrap align-center)
          v-flex(xs12 sm6 md3 style="padding: 6px;")
            v-text-field(
              outline
              v-model="filtroBusqueda"
              label="Buscar # factura, # fiscal, # pedido, cliente o RIF..."
              prepend-inner-icon="search"
              clearable
              hide-details
              @keyup.enter="cargarFacturas"
            )
          v-flex(xs12 sm6 md2 style="padding: 6px;")
            v-select(
              outline
              :items="opcionesEstadoSaldo"
              v-model="filtroEstadoSaldo"
              label="Estado de Cobro:"
              prepend-inner-icon="account_balance_wallet"
              hide-details
              @change="cargarFacturas"
            )
          v-flex(xs12 sm6 md2 style="padding: 6px;")
            v-select(
              outline
              :items="opcionesTipoFiscal"
              v-model="filtroTipoFiscal"
              label="Tipo de Factura:"
              prepend-inner-icon="verified_user"
              hide-details
            )
          v-flex(xs12 sm6 md2 style="padding: 6px;")
            v-select(
              outline
              :items="opcionesVendedores"
              v-model="filtroVendedor"
              label="Vendedor:"
              prepend-inner-icon="person"
              hide-details
              @change="cargarFacturas"
            )
          v-flex(xs12 sm6 md3 style="padding: 6px;")
            v-select(
              outline
              :items="modosVista"
              v-model="modoVista"
              label="Modo de Vista:"
              prepend-inner-icon="view_quilt"
              hide-details
            )

        v-layout(row wrap align-center style="margin-top: 4px;")
          v-flex(xs12 sm6 md3 style="padding: 6px;")
            v-select(
              outline
              :items="opcionesVencimiento"
              v-model="filtroVencimiento"
              label="Estado Vencimiento:"
              prepend-inner-icon="event_busy"
              hide-details
            )
          v-flex(xs12 sm6 md3 style="padding: 6px;")
            v-select(
              outline
              :items="opcionesContribuyente"
              v-model="filtroContribuyente"
              label="Tipo Contribuyente:"
              prepend-inner-icon="business"
              hide-details
            )
          v-flex(xs12 sm6 md3 style="padding: 6px;")
            v-menu(ref="menuFecha" v-model="menuFecha" :close-on-content-click="false" transition="scale-transition" offset-y max-width="320px")
              template(v-slot:activator="{ on }")
                v-text-field(
                  outline
                  v-model="fechaRangoTexto"
                  label="Rango Fecha Emisión"
                  prepend-inner-icon="date_range"
                  readonly
                  hide-details
                  v-on="on"
                  clearable
                  @click:clear="limpiarFechas"
                )
              v-date-picker(range v-model="fechas" no-title)
                v-spacer
                v-btn(flat color="primary" @click="menuFecha = false; cargarFacturas()") Aplicar
          v-flex(xs12 sm6 md3 style="padding: 6px; display: flex; justify-content: flex-end; gap: 8px;")
            v-btn(color="#0872e9" dark style="border-radius: 8px; text-transform: none; font-weight: 700;" @click="cargarFacturas" :loading="loading")
              v-icon(left small) search
              | Consultar / Actualizar

      //- Estado Cargando
      div(v-if="loading" style="text-align: center; padding: 60px 0; background: white; border-radius: 12px;" class="elevation-1")
        v-progress-circular(indeterminate color="#0872e9" size="56")
        div(style="margin-top: 14px; font-size: 15px; color: #64748b; font-weight: 600;")
          | Cargando y cruzando facturas fiscales y no fiscales...

      //- Estado Vacío
      div(v-else-if="facturasFiltradas.length === 0" style="text-align: center; padding: 60px 0; background: white; border-radius: 12px;" class="elevation-1")
        v-icon(size="64" color="grey lighten-1") receipt
        div(style="margin-top: 12px; font-size: 18px; font-weight: 800; color: #334155;")
          | No se encontraron facturas con los filtros seleccionados
        div(style="font-size: 13px; color: #94a3b8; margin-top: 4px;")
          | Prueba cambiando el filtro de Estado de Cobro, Tipo de Factura o buscando otro cliente/documento.

      //- ============================================================================
      //- MODO 1: TARJETAS ESTILO MÓDULO DE COBROS DE LA APP (Fiscales + No Fiscales)
      //- ============================================================================
      div(v-else-if="modoVista === 'tarjetas'")
        v-layout(row wrap style="margin: -6px;")
          v-flex(
            xs12
            md6
            lg4
            v-for="fact in facturasPaginadasTarjetas"
            :key="(fact.nro_doc || 'F') + '_' + (fact.factura_fiscal || 'NF') + '_' + (fact.nro_pedido || '')"
            style="padding: 6px;"
          )
            div(
              @click="abrirDetalle(fact)"
              style="background: white; border-radius: 14px; border: 1px solid #e4e7eb; padding: 14px; box-shadow: 0 3px 8px rgba(0,0,0,0.03); cursor: pointer; height: 100%; display: flex; flex-direction: column; justify-content: space-between; transition: all 0.18s;"
              class="factura-card-hover"
            )
              div
                //- Fila Superior: # Factura No Fiscal + # Pedido + Estado (Al día / Vencida)
                div(style="display: flex; justify-content: space-between; align-items: flex-start; gap: 8px; flex-wrap: wrap;")
                  div(style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;")
                    v-icon(size="18" color="#0872e9") receipt
                    span(style="color: #1d1e25; font-weight: 800; font-size: 16px;")
                      | {{ fact.nro_doc ? '#' + fact.nro_doc : 'Fiscal #' + fact.factura_fiscal }}
                    span(
                      v-if="fact.nro_pedido"
                      style="background: #f0f4f8; color: #455a64; border: 1px solid #cfd8dc; border-radius: 6px; padding: 2px 7px; font-size: 11px; font-weight: 700;"
                    )
                      | Ped: {{ '#' + fact.nro_pedido }}

                  //- Chip de Estado (Pagada / Vencida / Al día)
                  div(
                    v-if="fact.saldoNoFiscal <= 0 && (!fact.tieneFiscal || fact.saldoFiscal <= 0)"
                    style="background: #e0f2fe; border: 1px solid #bae6fd; color: #0369a1; border-radius: 6px; padding: 3px 8px; font-size: 11px; font-weight: 700; display: inline-flex; align-items: center; gap: 4px;"
                  )
                    v-icon(size="13" color="#0369a1") check_circle
                    span Pagada
                  div(
                    v-else-if="fact.isVencida"
                    style="background: #ffebee; border: 1px solid #ffcdd2; color: #d32f2f; border-radius: 6px; padding: 3px 8px; font-size: 11px; font-weight: 700; display: inline-flex; align-items: center; gap: 4px;"
                  )
                    v-icon(size="13" color="#d32f2f") error_outline
                    span {{ fact.diasVenc ? 'Vencida (' + fact.diasVenc + ' d)' : 'Vencida' }}
                  div(
                    v-else
                    style="background: #e8f5e9; border: 1px solid #c8e6c9; color: #2e7d32; border-radius: 6px; padding: 3px 8px; font-size: 11px; font-weight: 700; display: inline-flex; align-items: center; gap: 4px;"
                  )
                    v-icon(size="13" color="#2e7d32") check_circle_outline
                    span Al día

                //- Información del Cliente + Contribuyente Especial / Ordinario
                div(style="margin-top: 8px; padding: 8px 10px; background: #f8fafc; border-radius: 8px; border: 1px solid #eef2f6;")
                  div(style="font-weight: 700; font-size: 13px; color: #1d1e25; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" :title="fact.clienteNombre")
                    | {{ fact.clienteNombre }}
                  div(style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 4px; margin-top: 4px;")
                    span(style="font-size: 11px; color: #5a6e85; font-weight: 600;")
                      | Cód: {{ fact.clienteCodigo }} {{ fact.clienteRif ? '• ' + fact.clienteRif : '' }}
                    span(
                      v-if="fact.isContribEspecial"
                      style="background: #e8f5e9; color: #2e7d32; border: 1px solid #a5d6a7; padding: 1px 6px; border-radius: 5px; font-size: 10px; font-weight: 700;"
                    )
                      | Contrib. Especial ({{ fact.porcRetStr }})
                    span(
                      v-else
                      style="background: #f1f5f9; color: #64748b; padding: 1px 6px; border-radius: 5px; font-size: 10px; font-weight: 600;"
                    )
                      | Ordinario
                  div(style="font-size: 11px; color: #64748b; margin-top: 3px;")
                    | Vendedor: 
                    b(style="color: #334155;") {{ fact.ven_des }}

                //- Fechas: Emisión y Vencimiento
                div(style="display: flex; justify-content: space-between; margin-top: 8px; font-size: 11px; color: #546e7a;")
                  span
                    v-icon(size="12" color="#75838d" style="margin-right: 3px;") calendar_today
                    | Emisión: {{ formatearFecha(fact.fec_emis) }}
                  span(:style="{ color: fact.isVencida ? '#d32f2f' : '#546e7a', fontWeight: fact.isVencida ? '700' : '500' }")
                    v-icon(size="12" :color="fact.isVencida ? '#d32f2f' : '#75838d'" style="margin-right: 3px;") event
                    | Vence: {{ formatearFecha(fact.fec_venc) }}

                //- 1. Desglose Factura No Fiscal (USD) - Igual que _buildDesgloseNoFiscal en cobro_screen.dart
                div(style="margin-top: 10px; background: #f8fafd; border-radius: 10px; border: 1px solid #dce6f5; padding: 10px;")
                  div(style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px;")
                    v-icon(size="15" color="#0872e9") description
                    span(style="color: #0872e9; font-size: 12px; font-weight: 700;")
                      | Factura No Fiscal ({{ fact.nro_doc ? '#' + fact.nro_doc : 'S/N' }})
                  div(style="display: flex; justify-content: space-between;")
                    div
                      div(style="color: #546e7a; font-size: 10px; font-weight: 500;") Total Factura
                      div(style="color: #1d1e25; font-size: 13px; font-weight: 800;")
                        | $ {{ formatoMonto(fact.totalNoFiscal, 'USD') }}
                    div(style="text-align: right;")
                      div(style="color: #0872e9; font-size: 10px; font-weight: 700;") Saldo a Cobrar
                      div(style="color: #0872e9; font-size: 14px; font-weight: 900;")
                        | $ {{ formatoMonto(fact.saldoNoFiscal, 'USD') }}

                //- 2. Desglose Factura Fiscal (Bs) - Igual que _buildDesgloseFactura en cobro_screen.dart
                div(
                  v-if="fact.tieneFiscal"
                  style="margin-top: 8px; background: #f6fbf7; border-radius: 10px; border: 1px solid #c8e6c9; padding: 10px;"
                )
                  div(style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;")
                    div(style="display: flex; align-items: center; gap: 5px;")
                      v-icon(size="15" color="#2e7d32") verified_user
                      span(style="color: #2e7d32; font-size: 12px; font-weight: 700;")
                        | Factura Fiscal ({{ '#' + fact.factura_fiscal }})
                    span(
                      style="background: white; color: #2e7d32; border: 1px solid #c8e6c9; border-radius: 6px; padding: 1px 6px; font-size: 10px; font-weight: 700;"
                    )
                      | {{ fact.tasaParaFiscal > 0 ? 'Tasa: ' + formatoMonto(fact.tasaParaFiscal, 'BS') + ' Bs' : 'Fiscal (Bs)' }}

                  div(style="display: flex; justify-content: space-between; margin-bottom: 6px;")
                    div
                      div(style="color: #78909c; font-size: 10px;") Subtotal Base
                      div(style="color: #37474f; font-size: 12px; font-weight: 600;")
                        | Bs. {{ formatoMonto(fact.subtotalFiscal, 'BS') }}
                    div(style="text-align: right;")
                      div(style="color: #78909c; font-size: 10px;") IVA (16% Total)
                      div(style="color: #37474f; font-size: 12px; font-weight: 600;")
                        | Bs. {{ formatoMonto(fact.ivaFiscal, 'BS') }}

                  //- Retención si es Contribuyente Especial
                  div(
                    v-if="fact.tieneRetencion"
                    style="background: #fff8e1; border: 1px solid #ffe082; border-radius: 8px; padding: 5px 8px; margin-bottom: 6px;"
                  )
                    div(style="display: flex; justify-content: space-between; font-size: 10.5px;")
                      span(style="color: #e65100; font-weight: 600;") Retención IVA ({{ fact.porcRetStr }}):
                      span(style="color: #c62828; font-weight: 700;") -Bs. {{ formatoMonto(fact.retencionBs, 'BS') }}
                    div(style="display: flex; justify-content: space-between; font-size: 10.5px; margin-top: 2px;")
                      span(style="color: #2e7d32; font-weight: 700;") IVA a Pagar ({{ fact.porcIvaPagarStr }}):
                      span(style="color: #2e7d32; font-weight: 800;") Bs. {{ formatoMonto(fact.ivaPagarBs, 'BS') }}

                  div(style="display: flex; justify-content: space-between; padding-top: 4px; border-top: 1px dashed #c8e6c9;")
                    div
                      div(style="color: #546e7a; font-size: 10px; font-weight: 600;")
                        | {{ fact.tieneRetencion ? 'Total Fiscal a Pagar' : 'Total Fiscal' }}
                      div(style="color: #1d1e25; font-size: 12.5px; font-weight: 800;")
                        | Bs. {{ formatoMonto(fact.tieneRetencion ? fact.totalFiscalAPagar : fact.totalFiscal, 'BS') }}
                    div(style="text-align: right;")
                      div(style="color: #2e7d32; font-size: 10px; font-weight: 700;") Saldo Fiscal
                      div(style="color: #2e7d32; font-size: 13px; font-weight: 900;")
                        | Bs. {{ formatoMonto(fact.saldoFiscal, 'BS') }}

                div(
                  v-else
                  style="margin-top: 8px; background: #f5f7fa; border-radius: 8px; border: 1px solid #eceff1; padding: 7px 10px; display: flex; align-items: center; gap: 6px;"
                )
                  v-icon(size="14" color="#90a4ae") info_outline
                  span(style="color: #78909c; font-size: 11px; font-weight: 500;")
                    | Sin Factura Fiscal emitida asociada

              //- Paginación inferior para tarjetas
        div(v-if="totalPaginasTarjetas > 1" style="display: flex; justify-content: center; margin-top: 20px;")
          v-pagination(v-model="paginaTarjetas" :length="totalPaginasTarjetas" :total-visible="7" color="#0872e9")

      //- ============================================================================
      //- MODO 2: AGRUPADO POR CLIENTE (Igual a entrar por cliente en Cobros App)
      //- ============================================================================
      div(v-else-if="modoVista === 'clientes'")
        v-expansion-panel(expand style="border-radius: 10px; overflow: hidden;")
          v-expansion-panel-content(
            v-for="grupo in gruposPorCliente"
            :key="grupo.co_cli"
            style="background: white; margin-bottom: 8px; border-radius: 10px; border: 1px solid #e2e8f0;"
          )
            template(v-slot:header)
              v-layout(row wrap align-center style="padding: 4px 0;")
                v-flex(xs12 md5)
                  div(style="display: flex; align-items: center; gap: 10px;")
                    v-avatar(size="40" color="#0872e9" style="color: white; font-weight: 800; font-size: 14px;")
                      | {{ grupo.cli_des ? grupo.cli_des.charAt(0).toUpperCase() : 'C' }}
                    div
                      div(style="font-weight: 800; font-size: 15px; color: #0f172a;") {{ grupo.cli_des }}
                      div(style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap; margin-top: 2px;")
                        span(style="font-size: 11px; color: #64748b; font-weight: 600;") Cód: {{ grupo.co_cli }}
                        span(v-if="grupo.rif" style="font-size: 11px; color: #64748b;") • RIF: {{ grupo.rif }}
                        span(
                          v-if="grupo.isContribEspecial"
                          style="background: #e8f5e9; color: #2e7d32; border: 1px solid #a5d6a7; padding: 1px 6px; border-radius: 5px; font-size: 10px; font-weight: 700;"
                        )
                          | Contribuyente Especial (Ret. {{ grupo.porcRetStr }})
                        span(
                          v-else
                          style="background: #f1f5f9; color: #64748b; padding: 1px 6px; border-radius: 5px; font-size: 10px; font-weight: 600;"
                        )
                          | Ordinario

                v-flex(xs6 md3 text-xs-center)
                  v-chip(small color="#e6f1fd" text-color="#0872e9" style="font-weight: 700;")
                    | {{ grupo.facturas.length }} {{ grupo.facturas.length === 1 ? 'Factura' : 'Facturas' }}
                  v-chip(small color="#e8f5e9" text-color="#2e7d32" style="font-weight: 700;" v-if="grupo.conFiscal > 0")
                    | {{ grupo.conFiscal }} Fiscal(es)

                v-flex(xs6 md4 text-xs-right)
                  div(style="font-size: 11px; color: #64748b;")
                    | Total Facturas: 
                    b(style="color: #0f172a;") $ {{ formatoMonto(grupo.totalMontoUSD, 'USD') }}
                  div(style="font-size: 15px; font-weight: 900; color: #0872e9;")
                    | Saldo a Cobrar: $ {{ formatoMonto(grupo.totalSaldoUSD, 'USD') }}
                  div(v-if="grupo.totalIvaBs > 0" style="font-size: 11px; color: #2e7d32; font-weight: 700;")
                    | IVA Fiscal: Bs. {{ formatoMonto(grupo.isContribEspecial ? grupo.totalIvaAPagarBs : grupo.totalIvaBs, 'BS') }}

            v-card(color="#f8fafc" style="padding: 14px 18px; border-top: 1px solid #e2e8f0;")
              v-layout(row wrap style="margin: -6px;")
                v-flex(xs12 md6 lg4 v-for="fact in grupo.facturas" :key="fact.nro_doc || fact.factura_fiscal" style="padding: 6px;")
                  div(
                    @click="abrirDetalle(fact)"
                    style="background: white; border-radius: 12px; border: 1px solid #e2e8f0; padding: 12px; cursor: pointer;"
                    class="factura-card-hover"
                  )
                    div(style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;")
                      span(style="font-weight: 800; font-size: 15px; color: #0872e9;")
                        | {{ '#' + (fact.nro_doc || fact.factura_fiscal) }}
                      span(v-if="fact.nro_pedido" style="background: #f0f4f8; color: #455a64; padding: 2px 6px; border-radius: 5px; font-size: 11px; font-weight: 600;")
                        | Ped: {{ '#' + fact.nro_pedido }}
                      span(
                        :style="{ color: fact.isVencida ? '#d32f2f' : '#2e7d32', fontWeight: '700', fontSize: '11px' }"
                      )
                        | {{ fact.isVencida ? 'Vencida (' + (fact.diasVenc || '') + 'd)' : 'Al día' }}

                    div(style="font-size: 11px; color: #64748b; margin-bottom: 8px;")
                      | Emisión: {{ formatearFecha(fact.fec_emis) }} • Vence: {{ formatearFecha(fact.fec_venc) }}

                    //- No Fiscal
                    div(style="background: #f8fafd; border: 1px solid #dce6f5; border-radius: 8px; padding: 8px; margin-bottom: 6px;")
                      div(style="font-size: 11px; font-weight: 700; color: #0872e9; margin-bottom: 4px;")
                        | Factura No Fiscal ({{ '#' + (fact.nro_doc || 'S/N') }})
                      div(style="display: flex; justify-content: space-between; font-size: 12px;")
                        span Total: 
                          b $ {{ formatoMonto(fact.totalNoFiscal, 'USD') }}
                        span(style="color: #0872e9; font-weight: 800;") Saldo: $ {{ formatoMonto(fact.saldoNoFiscal, 'USD') }}

                    //- Fiscal
                    div(v-if="fact.tieneFiscal" style="background: #f6fbf7; border: 1px solid #c8e6c9; border-radius: 8px; padding: 8px;")
                      div(style="display: flex; justify-content: space-between; font-size: 11px; font-weight: 700; color: #2e7d32; margin-bottom: 4px;")
                        span Factura Fiscal ({{ '#' + fact.factura_fiscal }})
                        span(v-if="fact.tasaParaFiscal > 0") Tasa: {{ formatoMonto(fact.tasaParaFiscal, 'BS') }} Bs
                      div(style="display: flex; justify-content: space-between; font-size: 11px; color: #37474f;")
                        span Base: Bs. {{ formatoMonto(fact.subtotalFiscal, 'BS') }}
                        span IVA 16%: Bs. {{ formatoMonto(fact.ivaFiscal, 'BS') }}
                      div(v-if="fact.tieneRetencion" style="font-size: 11px; color: #c62828; font-weight: 700; margin-top: 2px;")
                        | Ret. ({{ fact.porcRetStr }}): -Bs. {{ formatoMonto(fact.retencionBs, 'BS') }} | IVA Pagar: Bs. {{ formatoMonto(fact.ivaPagarBs, 'BS') }}
                      div(style="display: flex; justify-content: space-between; font-size: 12px; font-weight: 800; color: #2e7d32; margin-top: 4px; padding-top: 4px; border-top: 1px dashed #c8e6c9;")
                        span Total Bs: {{ formatoMonto(fact.tieneRetencion ? fact.totalFiscalAPagar : fact.totalFiscal, 'BS') }}
                        span Saldo Bs: {{ formatoMonto(fact.saldoFiscal, 'BS') }}
                    div(v-else style="background: #f5f7fa; border: 1px solid #eceff1; border-radius: 8px; padding: 6px 8px; font-size: 11px; color: #78909c;")
                      | Sin Factura Fiscal emitida asociada

      //- ============================================================================
      //- MODO 3: TABLA CONSOLIDADA (Fiscales y No Fiscales en una sola tabla)
      //- ============================================================================
      div(v-else)
        v-card(color="white" style="border-radius: 10px; overflow: hidden;" class="elevation-2")
          v-data-table(
            :headers="headersTabla"
            :items="facturasFiltradas"
            :pagination.sync="pagination"
            :rows-per-page-items="[15, 25, 50, 100]"
            class="elevation-0"
          )
            template(v-slot:items="props")
              tr(@click="abrirDetalle(props.item)" style="cursor: pointer;")
                td.text-xs-center(style="white-space: nowrap;")
                  div(style="font-weight: 700; color: #0f172a; font-size: 12px;") {{ formatearFecha(props.item.fec_emis) }}
                  div(:style="{ fontSize: '11px', color: props.item.isVencida ? '#d32f2f' : '#64748b', fontWeight: props.item.isVencida ? '700' : '400' }")
                    | Vence: {{ formatearFecha(props.item.fec_venc) }}
                td
                  div(style="font-weight: 700; color: #0f172a; font-size: 13px;") {{ props.item.clienteNombre }}
                  div(style="font-size: 11px; color: #64748b;")
                    | {{ props.item.clienteCodigo }} {{ props.item.clienteRif ? '• ' + props.item.clienteRif : '' }}
                  div(v-if="props.item.isContribEspecial" style="margin-top: 2px;")
                    span(style="background: #e8f5e9; color: #2e7d32; border: 1px solid #a5d6a7; padding: 1px 5px; border-radius: 4px; font-size: 10px; font-weight: 700;")
                      | Contrib. Especial ({{ props.item.porcRetStr }})
                td.text-xs-center
                  div(style="font-size: 12px; font-weight: 600; color: #334155;") {{ props.item.ven_des }}
                  div(style="font-size: 10px; color: #64748b;") Cód: {{ props.item.co_ven }}
                td.text-xs-center
                  div(style="font-weight: 800; color: #0872e9; font-size: 14px;")
                    | {{ props.item.nro_doc ? '#' + props.item.nro_doc : 'S/N' }}
                  div(v-if="props.item.nro_pedido" style="font-size: 11px; color: #475569; font-weight: 600;")
                    | Ped: {{ '#' + props.item.nro_pedido }}
                td.text-xs-right(style="white-space: nowrap;")
                  div(style="font-size: 12px; color: #475569;") Total: $ {{ formatoMonto(props.item.totalNoFiscal, 'USD') }}
                  div(style="font-size: 13px; font-weight: 900; color: #0872e9;") Saldo: $ {{ formatoMonto(props.item.saldoNoFiscal, 'USD') }}
                td.text-xs-center
                  div(v-if="props.item.tieneFiscal")
                    span(style="background: #e8f5e9; color: #2e7d32; border: 1px solid #a5d6a7; padding: 2px 8px; border-radius: 6px; font-weight: 800; font-size: 12px;")
                      | {{ '#' + props.item.factura_fiscal }}
                    div(v-if="props.item.tasaParaFiscal > 0" style="font-size: 10px; color: #2e7d32; font-weight: 600; margin-top: 2px;")
                      | Tasa: {{ formatoMonto(props.item.tasaParaFiscal, 'BS') }} Bs
                  span(v-else style="color: #94a3b8; font-size: 11px; font-style: italic;") Sin Fiscal
                td.text-xs-right(style="white-space: nowrap;")
                  div(v-if="props.item.tieneFiscal")
                    div(style="font-size: 11px; color: #475569;") Base: Bs. {{ formatoMonto(props.item.subtotalFiscal, 'BS') }}
                    div(style="font-size: 11px; color: #2e7d32; font-weight: 700;") IVA 16%: Bs. {{ formatoMonto(props.item.ivaFiscal, 'BS') }}
                    div(v-if="props.item.tieneRetencion" style="font-size: 10.5px; color: #c62828; font-weight: 700;")
                      | Ret. ({{ props.item.porcRetStr }}): -Bs. {{ formatoMonto(props.item.retencionBs, 'BS') }}
                    div(style="font-size: 12px; font-weight: 800; color: #0f172a;")
                      | Total: Bs. {{ formatoMonto(props.item.tieneRetencion ? props.item.totalFiscalAPagar : props.item.totalFiscal, 'BS') }}
                  span(v-else style="color: #cbd5e1;") —
                td.text-xs-center
                  v-chip(
                    v-if="props.item.saldoNoFiscal <= 0 && (!props.item.tieneFiscal || props.item.saldoFiscal <= 0)"
                    small
                    color="#e0f2fe"
                    text-color="#0369a1"
                    style="font-weight: 700; font-size: 11px;"
                  ) Pagada
                  v-chip(
                    v-else-if="props.item.isVencida"
                    small
                    color="#ffebee"
                    text-color="#d32f2f"
                    style="font-weight: 700; font-size: 11px;"
                  ) {{ props.item.diasVenc ? 'Vencida (' + props.item.diasVenc + 'd)' : 'Vencida' }}
                  v-chip(
                    v-else
                    small
                    color="#e8f5e9"
                    text-color="#2e7d32"
                    style="font-weight: 700; font-size: 11px;"
                  ) Al día
                td.text-xs-center
                  v-btn(icon small color="#0872e9" @click.stop="abrirDetalle(props.item)" title="Ver desglose completo")
                    v-icon(small) visibility
</template>

<script>
import Api from "@/services/methods";
import moment from "moment";

export default {
  name: "FacturasUnificadas",
  data: () => ({
    loading: false,
    facturasRaw: [],
    vendedoresList: [],
    filtroBusqueda: "",
    filtroEstadoSaldo: "pendientes",
    filtroTipoFiscal: "todas",
    filtroVendedor: "TODOS",
    filtroVencimiento: "todas",
    filtroContribuyente: "todos",
    modoVista: "tarjetas",
    fechas: [],
    menuFecha: false,
    paginaTarjetas: 1,
    tarjetasPorPagina: 18,
    dialogDetalle: false,
    itemSel: null,
    pagination: {
      rowsPerPage: 25,
      sortBy: "fec_emis",
      descending: true
    },
    opcionesEstadoSaldo: [
      { text: "Pendientes por cobrar (Saldo > 0)", value: "pendientes" },
      { text: "Pagadas (Saldo = 0)", value: "pagadas" },
      { text: "Todas las facturas", value: "todas" }
    ],
    opcionesTipoFiscal: [
      { text: "Todas (Fiscales y No Fiscales)", value: "todas" },
      { text: "Con Factura Fiscal asociada", value: "con_fiscal" },
      { text: "Solo No Fiscal (Sin Fiscal)", value: "sin_fiscal" }
    ],
    opcionesVencimiento: [
      { text: "Todas (Al día + Vencidas)", value: "todas" },
      { text: "Solo Vencidas", value: "vencidas" },
      { text: "Solo Al día", value: "al_dia" }
    ],
    opcionesContribuyente: [
      { text: "Todos los Clientes", value: "todos" },
      { text: "Contribuyentes Especiales", value: "especial" },
      { text: "Contribuyentes Ordinarios", value: "ordinario" }
    ],
    modosVista: [
      { text: "Tarjetas (Estilo App Cobros)", value: "tarjetas" },
      { text: "Agrupado por Cliente", value: "clientes" },
      { text: "Tabla Consolidada", value: "tabla" }
    ],
    headersTabla: [
      { text: "Emisión / Vence", value: "fec_emis", align: "center", sortable: true },
      { text: "Cliente", value: "clienteNombre", align: "left", sortable: true },
      { text: "Vendedor", value: "ven_des", align: "center", sortable: true },
      { text: "Factura No Fiscal / Pedido", value: "nro_doc", align: "center", sortable: true },
      { text: "Monto / Saldo (USD)", value: "saldoNoFiscal", align: "right", sortable: true },
      { text: "Factura Fiscal", value: "factura_fiscal", align: "center", sortable: true },
      { text: "Desglose Fiscal (Bs)", value: "totalFiscal", align: "right", sortable: true },
      { text: "Estado", value: "isVencida", align: "center", sortable: true },
      { text: "Detalle", value: "acciones", align: "center", sortable: false }
    ]
  }),
  computed: {
    fechaRangoTexto() {
      if (!this.fechas || this.fechas.length === 0) return "";
      const ordenadas = [...this.fechas].sort();
      if (ordenadas.length === 1) return ordenadas[0];
      return `${ordenadas[0]} al ${ordenadas[1]}`;
    },
    opcionesVendedores() {
      const base = [{ text: "Todos los vendedores", value: "TODOS" }];
      const vistos = new Set();
      this.vendedoresList.forEach(v => {
        const co = (v.co_ven || "").toString().trim();
        const des = (v.ven_des || "").toString().trim();
        if (co && !vistos.has(co)) {
          vistos.add(co);
          base.push({
            text: des ? `${des} (${co})` : co,
            value: co
          });
        }
      });
      return base;
    },
    facturasProcesadas() {
      return this.facturasRaw.map(f => this.enriquecerFactura(f));
    },
    facturasFiltradas() {
      const q = (this.filtroBusqueda || "").toString().trim().toLowerCase();
      return this.facturasProcesadas.filter(f => {
        if (this.filtroTipoFiscal === "con_fiscal" && !f.tieneFiscal) return false;
        if (this.filtroTipoFiscal === "sin_fiscal" && f.tieneFiscal) return false;

        if (this.filtroVencimiento === "vencidas" && !f.isVencida) return false;
        if (this.filtroVencimiento === "al_dia" && f.isVencida) return false;

        if (this.filtroContribuyente === "especial" && !f.isContribEspecial) return false;
        if (this.filtroContribuyente === "ordinario" && f.isContribEspecial) return false;

        if (q) {
          const nroDoc = (f.nro_doc || "").toString().toLowerCase();
          const nroFiscal = (f.factura_fiscal || "").toString().toLowerCase();
          const nroPedido = (f.nro_pedido || "").toString().toLowerCase();
          const cliNombre = (f.clienteNombre || "").toString().toLowerCase();
          const cliCod = (f.clienteCodigo || "").toString().toLowerCase();
          const cliRif = (f.clienteRif || "").toString().toLowerCase();
          const venNombre = (f.ven_des || "").toString().toLowerCase();
          const comen = (f.comentario || "").toString().toLowerCase();

          const coincide =
            nroDoc.includes(q) ||
            nroFiscal.includes(q) ||
            nroPedido.includes(q) ||
            cliNombre.includes(q) ||
            cliCod.includes(q) ||
            cliRif.includes(q) ||
            venNombre.includes(q) ||
            comen.includes(q);
          if (!coincide) return false;
        }
        return true;
      });
    },
    totalPaginasTarjetas() {
      return Math.ceil(this.facturasFiltradas.length / this.tarjetasPorPagina) || 1;
    },
    facturasPaginadasTarjetas() {
      const inicio = (this.paginaTarjetas - 1) * this.tarjetasPorPagina;
      return this.facturasFiltradas.slice(inicio, inicio + this.tarjetasPorPagina);
    },
    kpis() {
      let conFiscal = 0;
      let sinFiscal = 0;
      let totalMontoUSD = 0;
      let totalSaldoUSD = 0;
      let totalIvaBs = 0;
      let totalRetencionBs = 0;
      let totalIvaAPagarBs = 0;
      let totalFiscalBs = 0;

      for (let i = 0; i < this.facturasFiltradas.length; i++) {
        const f = this.facturasFiltradas[i];
        totalMontoUSD += f.totalNoFiscal;
        totalSaldoUSD += f.saldoNoFiscal;
        if (f.tieneFiscal) {
          conFiscal++;
          totalIvaBs += f.ivaFiscal;
          totalRetencionBs += f.retencionBs;
          totalIvaAPagarBs += f.ivaPagarBs;
          totalFiscalBs += f.tieneRetencion ? f.totalFiscalAPagar : f.totalFiscal;
        } else {
          sinFiscal++;
        }
      }

      return {
        conFiscal,
        sinFiscal,
        totalMontoUSD,
        totalSaldoUSD,
        totalIvaBs,
        totalRetencionBs,
        totalIvaAPagarBs,
        totalFiscalBs
      };
    },
    gruposPorCliente() {
      const mapa = {};
      for (let i = 0; i < this.facturasFiltradas.length; i++) {
        const f = this.facturasFiltradas[i];
        const key = f.clienteCodigo || "SIN_CLIENTE";
        if (!mapa[key]) {
          mapa[key] = {
            co_cli: f.clienteCodigo,
            cli_des: f.clienteNombre,
            rif: f.clienteRif,
            isContribEspecial: f.isContribEspecial,
            porcRetStr: f.porcRetStr,
            facturas: [],
            conFiscal: 0,
            totalMontoUSD: 0,
            totalSaldoUSD: 0,
            totalIvaBs: 0,
            totalIvaAPagarBs: 0
          };
        }
        mapa[key].facturas.push(f);
        mapa[key].totalMontoUSD += f.totalNoFiscal;
        mapa[key].totalSaldoUSD += f.saldoNoFiscal;
        if (f.tieneFiscal) {
          mapa[key].conFiscal++;
          mapa[key].totalIvaBs += f.ivaFiscal;
          mapa[key].totalIvaAPagarBs += f.ivaPagarBs;
        }
      }
      return Object.values(mapa).sort((a, b) => b.totalSaldoUSD - a.totalSaldoUSD);
    }
  },
  watch: {
    filtroBusqueda() {
      this.paginaTarjetas = 1;
    },
    filtroTipoFiscal() {
      this.paginaTarjetas = 1;
    },
    filtroVencimiento() {
      this.paginaTarjetas = 1;
    },
    filtroContribuyente() {
      this.paginaTarjetas = 1;
    }
  },
  created() {
    this.cargarVendedores();
    this.cargarFacturas();
  },
  methods: {
    parseNum(val) {
      if (val === null || val === undefined) return 0;
      if (typeof val === "number") return isNaN(val) ? 0 : val;
      const num = parseFloat(val.toString().replace(",", "."));
      return isNaN(num) ? 0 : num;
    },
    enriquecerFactura(factura) {
      // Exactamente la misma lógica de cobro_screen.dart en la app móvil
      const nroDoc = factura.nro_doc ? factura.nro_doc.toString().trim() : null;
      const nroPedido = factura.nro_pedido ? factura.nro_pedido.toString().trim() : null;
      const facturaFiscal = factura.factura_fiscal ? factura.factura_fiscal.toString().trim() : null;
      const tieneFiscal = Boolean(facturaFiscal && facturaFiscal.length > 0);

      const saldo = this.parseNum(factura.saldo);
      const totalNeto = this.parseNum(factura.total_neto);
      const totalBruto = this.parseNum(factura.total_bruto);

      // 1. Factura No Fiscal (USD)
      const totalNoFiscal = totalBruto > 0 ? totalBruto : totalNeto > 0 ? totalNeto : saldo;
      const saldoNoFiscal = saldo;

      // Datos del cliente y condición de Contribuyente Especial
      const cli = factura.cliente || {};
      const clienteNombre = (cli.cli_des || cli.nombre || factura.co_cli || "Cliente no disponible").toString().trim();
      const clienteCodigo = (cli.co_cli || factura.co_cli || "N/A").toString().trim();
      const clienteRif = (cli.rif || "").toString().trim();

      const rawContrib = cli.contribu_e !== undefined ? cli.contribu_e : cli.contrib;
      const isContribEspecial = Boolean(
        rawContrib === true ||
          rawContrib === 1 ||
          String(rawContrib || "").trim().toLowerCase() === "true" ||
          String(rawContrib || "").trim() === "1"
      );

      const porcRet = this.parseNum(cli.porc_esp) > 0 ? this.parseNum(cli.porc_esp) : 75;
      const porcIvaPagar = Math.max(0, Math.min(100, 100 - porcRet));
      const porcRetStr = `${porcRet % 1 === 0 ? Math.round(porcRet) : porcRet}%`;
      const porcIvaPagarStr = `${porcIvaPagar % 1 === 0 ? Math.round(porcIvaPagar) : porcIvaPagar}%`;

      // 2. Factura Fiscal (Bs)
      const tasaFiscalNum = this.parseNum(factura.tasa_fiscal);
      const tasaNormal = this.parseNum(factura.tasa);
      const tasaParaFiscal = tasaFiscalNum > 0 ? tasaFiscalNum : tasaNormal > 0 ? tasaNormal : 0;

      const rawFiscalBruto = this.parseNum(factura.fiscal_total_bruto);
      const rawFiscalImp = this.parseNum(factura.fiscal_monto_imp);
      const rawFiscalNeto = this.parseNum(factura.fiscal_total_neto);
      const rawFiscalSaldo = this.parseNum(factura.fiscal_saldo);

      const subtotalFiscal =
        rawFiscalBruto > 0
          ? rawFiscalBruto
          : rawFiscalNeto > 0
          ? rawFiscalNeto - rawFiscalImp
          : tasaParaFiscal > 0
          ? totalNoFiscal * tasaParaFiscal
          : 0;

      const ivaFiscal =
        rawFiscalImp > 0
          ? rawFiscalImp
          : subtotalFiscal > 0
          ? subtotalFiscal * 0.16
          : 0;

      const totalFiscal =
        rawFiscalNeto > 0 && rawFiscalNeto >= subtotalFiscal
          ? rawFiscalNeto
          : subtotalFiscal + ivaFiscal;

      const saldoFiscal =
        rawFiscalSaldo > 0
          ? rawFiscalSaldo
          : tasaParaFiscal > 0
          ? saldoNoFiscal * tasaParaFiscal
          : totalFiscal;

      const retencionBs = isContribEspecial && ivaFiscal > 0 ? ivaFiscal * (porcRet / 100) : 0;
      const ivaPagarBs = isContribEspecial && ivaFiscal > 0 ? ivaFiscal - retencionBs : ivaFiscal;
      const totalFiscalAPagar = isContribEspecial && retencionBs > 0 ? totalFiscal - retencionBs : totalFiscal;
      const tieneRetencion = isContribEspecial && retencionBs > 0;

      // Vencimiento
      let isVencida = false;
      let diasVenc = null;
      if (factura.fec_venc && (saldoNoFiscal > 0 || (tieneFiscal && saldoFiscal > 0))) {
        const venc = moment(factura.fec_venc).startOf("day");
        const hoy = moment().startOf("day");
        if (venc.isValid() && venc.isBefore(hoy)) {
          isVencida = true;
          diasVenc = hoy.diff(venc, "days");
        }
      }

      return {
        ...factura,
        nro_doc: nroDoc,
        nro_pedido: nroPedido,
        factura_fiscal: facturaFiscal,
        tieneFiscal,
        totalNoFiscal,
        saldoNoFiscal,
        tasaParaFiscal,
        subtotalFiscal,
        ivaFiscal,
        totalFiscal,
        saldoFiscal,
        retencionBs,
        ivaPagarBs,
        totalFiscalAPagar,
        tieneRetencion,
        clienteNombre,
        clienteCodigo,
        clienteRif,
        isContribEspecial,
        porcRet,
        porcRetStr,
        porcIvaPagarStr,
        isVencida,
        diasVenc
      };
    },
    cargarVendedores() {
      Api.get("vendedor")
        .then(res => {
          if (Array.isArray(res.data)) {
            this.vendedoresList = res.data;
          }
        })
        .catch(err => {
          console.error("Error cargando vendedores:", err);
        });
    },
    cargarFacturas() {
      this.loading = true;
      const params = new URLSearchParams();
      params.append("estadoSaldo", this.filtroEstadoSaldo || "pendientes");
      params.append("tipoFiscal", this.filtroTipoFiscal || "todas");
      params.append("limit", "600");

      if (this.filtroVendedor && this.filtroVendedor !== "TODOS") {
        params.append("co_ven", this.filtroVendedor);
      }
      if (this.filtroBusqueda && this.filtroBusqueda.trim()) {
        params.append("search", this.filtroBusqueda.trim());
      }
      if (this.fechas && this.fechas.length > 0) {
        const ordenadas = [...this.fechas].sort();
        params.append("desde", ordenadas[0]);
        params.append("hasta", ordenadas[ordenadas.length - 1]);
      }

      Api.get(`factura/admin-unificadas?${params.toString()}`)
        .then(res => {
          this.facturasRaw = Array.isArray(res.data) ? res.data : [];
          this.paginaTarjetas = 1;
        })
        .catch(err => {
          console.error("Error al cargar facturas unificadas:", err);
          this.$swal("Error", "No se pudieron cargar las facturas.", "error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    limpiarFechas() {
      this.fechas = [];
      this.cargarFacturas();
    },
    abrirDetalle(item) {
      this.itemSel = item;
      this.dialogDetalle = true;
    },
    formatearFecha(fecha) {
      if (!fecha) return "-";
      const m = moment.utc(fecha);
      return m.isValid() ? m.format("DD/MM/YYYY") : fecha;
    },
    formatoMonto(valor, moneda = "USD") {
      const num = this.parseNum(valor);
      if (moneda === "BS") {
        return num.toLocaleString("es-VE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      return num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }
};
</script>

<style scoped>
.factura-card-hover:hover {
  border-color: #0872e9 !important;
  box-shadow: 0 6px 16px rgba(8, 114, 233, 0.12) !important;
  transform: translateY(-2px);
}
</style>

